export default [
  {
    path: '/office',
    name: 'office',
    component: () => import('@/views/Office/index'),
    children: [
      {
        name: 'rent',
        component: () => import('@/views/Office/list'),
      },
      {
        name: 'sale',
        component: () => import('@/views/Office/list'),
      },
      {
        name: 'first-rent',
        component: () => import('@/views/Office/list'),
      },
      {
        name: 'first-sale',
        component: () => import('@/views/Office/list'),
      },
      {
        name: 'building-detail', //一手项目详情
        component: () => import('@/views/Office/buildingDetail'),
      },
      {
        name: 'house-detail',
        component: () => import('@/views/Office/houseDetail'),
      },
      {
        name: 'room-detail', //房间详情
        component: () => import('@/views/Office/roomDetail'),
      },
      {
        name: 'first-detail',
        component: () => import('@/views/Office/houseDetail'),
      },
      {
        name: 'edifice-detail', //大厦详情
        component: () => import('@/views/Office/buildingDetail'),
      },
    ],
  },
];
